// extracted by mini-css-extract-plugin
export var text = "_aa-0";